import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  pedidosventasStartLoad,
  pedidoventaClearActive,
} from "../../../actions";
import { PedidoVentaScreen } from "./PedidoVentaScreen";
import { PedidoVentaSearchList } from "./PedidoVentaSearchList";
import { PedidoVentaTable } from "./PedidoVentaTable";
import { PageHeaderUi } from "../../ui/PageHeaderUi";
import { NewBtn, ReLoadBtn } from "../../ui";

const PedidoVentaListScreen = ({ handleOpenForm }) => {
  const dispatch = useDispatch();
  const { pedidosventas, loading, paginator } = useSelector(
    (state) => state.pedidoventa,
  );
  const handleLoadPedidoVenta = () => {
    dispatch(pedidosventasStartLoad({}));
  };
  return (
    <>
      <PageHeaderUi
        title="Pedidos de Venta"
        subTitle="Listado"
        extra={[
          <ReLoadBtn key="actualizar" onClick={handleLoadPedidoVenta} />,
          <NewBtn key="nuevo" onClick={handleOpenForm} />,
        ]}
      >
        <div style={{ overflow: "hidden" }}>
          <PedidoVentaSearchList />
          <Row>
            <Col sm={32} md={32} xl={24}>
              <PedidoVentaTable
                pedidos={pedidosventas}
                loading={loading}
                paginator={paginator}
                handleOpenForm={handleOpenForm}
              />
            </Col>
          </Row>
        </div>
      </PageHeaderUi>
    </>
  );
};

export const PedidoVentaList = () => {
  const dispatch = useDispatch();
  const [openForm, setOpenForm] = useState(false);
  const handleOpenForm = () => setOpenForm(true);
  const handleCloseForm = () => {
    dispatch(pedidoventaClearActive());
    setOpenForm(false);
  };
  useEffect(() => {
    dispatch(pedidosventasStartLoad({}));
  }, []);
  if (openForm) {
    return <PedidoVentaScreen handleCloseForm={handleCloseForm} />;
  } else {
    return <PedidoVentaListScreen handleOpenForm={handleOpenForm} />;
  }
};
export default PedidoVentaList;
